/** PURE_IMPORTS_START .._operators_publishBehavior PURE_IMPORTS_END */
import { publishBehavior as higherOrder } from '../operators/publishBehavior';
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */
export function publishBehavior(value) {
    return higherOrder(value)(this);
}
//# sourceMappingURL=publishBehavior.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/operator/publishBehavior.js
// module id = 545
// module chunks = 0